import { render, staticRenderFns } from "./PartnershipIcons.vue?vue&type=template&id=d3bf6fee&"
import script from "./PartnershipIcons.vue?vue&type=script&lang=js&"
export * from "./PartnershipIcons.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports